import { useEffect, useState, useRef } from "react";
import { Table } from "antd";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import StatusTag from "../../../components/StatusTag";

const FreeTrialExpiredList = () => {
  const calledOnce = useRef(false);
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const FREE_TRIAL_EXPIRED_LIST = () => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.free_trial_expired_list, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res?.data);
        } else {
          set_page_loader(false);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    } finally {
      set_page_loader(false);
    }
  };

  useEffect(() => {
    if (!calledOnce.current) {
      FREE_TRIAL_EXPIRED_LIST();
      calledOnce.current = true;
    }
  }, []);

  const columns = [
    {
      title: "Company Name",
      dataIndex: "company_name",
      align: "center",
      key: "company_name",
    },
    {
      title: "Email",
      dataIndex: "company_email",
      align: "center",
      key: "company_email",
    },

    {
      title: "Country",
      dataIndex: "country",
      align: "center",
      key: "country",
    },

    {
      title: "Demo Status",
      dataIndex: "all_status",
      align: "center",
      key: "all_status",
      render: (all_status) => (
        <StatusTag status={all_status ? all_status : ""} />
      ),
    },
    {
      title: "Trial Status",
      dataIndex: "trial_status",
      align: "center",
      key: "trial_status",
      render: (trial_status) => (
        <StatusTag status={trial_status ? trial_status : ""} />
      ),
    },
    {
      title: "Expired Status",
      dataIndex: "expired_status",
      align: "center",
      key: "expired_status",
      render: (expired_status) => (
        <StatusTag status={expired_status ? expired_status : ""} />
      ),
    },
   
    {
      title: "Expired Date",
      dataIndex: "end_date",
      align: "center",
      key: "end_date",
      render: (text, record) => new Date(record?.end_date).toLocaleString(),
    },
  ];

  return (
    <>
      <div>
        <div className="row" style={{ padding: "10px" }}>
          <div
            className="col-3"
            style={{ marginLeft: "5px", alignSelf: "end" }}
          >
            <div className="theme-content-title text-left">
              <h3>Free Trial Expired List</h3>
            </div>
          </div>
          <div className="col-3"></div>
        </div>
        <Table
          bordered
          columns={columns}
          dataSource={filteredData}
          pagination={{ pageSize: 10 }}
          rowKey="key"
          loading={page_loader}
          className="custom-table"
        />
      </div>
    </>
  );
};

export default FreeTrialExpiredList;
